import { axiosEjFetch as axiosFetch } from "./axiosEjHelpers";

export async function uploadTestPhoto(reservationId: string, photoFile: File) {
  const formData = new FormData();
  formData.append("reservationId", reservationId);
  formData.append("file", photoFile);

  return axiosFetch.post("/api/tests/uploadTestPhotos", formData, {
    "Content-Type": "multipart/form-data",
  });
}
